import { handleActions } from "redux-actions";
import { fromJS } from "immutable";
import types from "../types";

const INITIAL_STATE = fromJS({
  isLoading: false,
  data: [],
});

const reducer = handleActions(
  {
    [types.GET]: (state) => state.set("isLoading", true),
    [types.GET_FAIL]: (state) => state.set("isLoading", false),
    [types.GET_SUCCESS]: (state, { payload: response }) =>
      state.set("isLoading", false).set("data", response.data),
  },
  INITIAL_STATE
);

export default reducer;
